// Follower-Dashboard (Social Phase 1): pro Netzwerk aktuelle Follower-Zahl,
// Veränderung über 7/30/90 Tage (abs + %) und eine 30-Punkte-Sparkline.
// Eine gemeinsame wipakademie-Präsenz (channel = Netzwerk). Liest /api/marketing/followers.
// Markenlogos inline (simple-icons-Pfade), Refresh startet den social_analytics-Motor.
import type { MarketingDeps } from "./marketing.js";
import { wireMotorRun } from "./marketing-poll.js";

interface Delta { abs: number; pct: number; from: number }
interface NetFollowers {
  channel: string; current: number; capturedAt: string;
  d7: Delta; d30: Delta; d90: Delta; spark: number[];
}
interface Reichweite { posts: number; wert: number; proBeitrag: number; basis: "reach" | "impressions" | "views" | "keine"; interactions: number }
interface Sitzungen {
  tage: number; von: string; bis: string; organisch: number; bezahlt: number; kaeufe: number; umsatz: number; proWoche: number;
  orgKaeufe?: number; orgUmsatz?: number; paidKaeufe?: number; paidUmsatz?: number; paidKosten?: number;
}
interface FollowersResponse {
  networks: NetFollowers[];
  reichweite?: Record<string, Reichweite>;
  reichweiteTage?: number;
  sitzungen?: Sitzungen | null;
}

export const NETS: Record<string, { label: string; color: string; path: string }> = {
  facebook: { label: "Facebook", color: "#1877F2", path: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" },
  instagram: { label: "Instagram", color: "#E1306C", path: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" },
  youtube: { label: "YouTube", color: "#FF0000", path: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" },
  tiktok: { label: "TikTok", color: "#010101", path: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" },
  pinterest: { label: "Pinterest", color: "#E60023", path: "M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.748-1.378l-.747 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z" },
};

const fmt = (n: number): string => n.toLocaleString("de-DE", { maximumFractionDigits: 0 });
const fmtPct = (p: number): string => `${p >= 0 ? "+" : ""}${p.toLocaleString("de-DE", { maximumFractionDigits: 1 })}%`;
const fmtAbs = (n: number): string => `${n >= 0 ? "+" : ""}${fmt(n)}`;
const cls = (d: Delta): string => (d.abs > 0 ? "up" : d.abs < 0 ? "down" : "flat");

function sparkline(vals: number[], color: string): string {
  if (vals.length < 2) return "";
  const W = 120, H = 30, lo = Math.min(...vals), hi = Math.max(...vals), span = hi - lo || 1;
  const pts = vals.map((v, i) => {
    const x = (i / (vals.length - 1)) * W;
    const y = H - 2 - ((v - lo) / span) * (H - 4);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(" ");
  return `<svg class="om-foll-spark" viewBox="0 0 ${W} ${H}" preserveAspectRatio="none"><polyline points="${pts}" fill="none" stroke="${color}" stroke-width="1.6"/></svg>`;
}

// Jedes Netz misst anders — was hier steht, ist beschriftet, damit niemand Äpfel mit Birnen
// vergleicht. Pinterest liefert nur Einblendungen, YouTube nur Views, der Rest echte Reichweite.
const BASIS_LABEL: Record<Reichweite["basis"], string> = {
  reach: "Reichweite ø/Beitrag",
  impressions: "Einblendungen ø/Beitrag",
  views: "Views ø/Beitrag",
  keine: "keine Reichweitendaten",
};

function reichweiteZeile(r: Reichweite | undefined, tage: number): string {
  if (!r || !r.posts) return `<div class="om-foll-reach dim">keine Beiträge in ${tage} T</div>`;
  if (r.basis === "keine") return `<div class="om-foll-reach dim">${r.posts} Beiträge · keine Reichweitendaten</div>`;
  return `<div class="om-foll-reach">
    <b>${fmt(r.proBeitrag)}</b> <span>${BASIS_LABEL[r.basis]}</span>
    <i>${fmt(r.wert)} gesamt · ${r.posts} Beiträge · ${fmt(r.interactions)} Interakt. (${tage} T)</i>
  </div>`;
}

function card(n: NetFollowers, reich: Record<string, Reichweite>, tage: number): string {
  const meta = NETS[n.channel] ?? { label: n.channel, color: "#888", path: "" };
  const logo = meta.path
    ? `<svg viewBox="0 0 24 24" width="22" height="22" fill="${meta.color}"><path d="${meta.path}"/></svg>`
    : "";
  const deltaTag = (label: string, d: Delta): string =>
    `<span class="om-foll-delta ${cls(d)}"><b>${label}</b> ${fmtAbs(d.abs)} <i>${fmtPct(d.pct)}</i></span>`;
  return `<div class="om-foll-card" style="border-top-color:${meta.color}">
    <div class="om-foll-head">${logo}<span class="om-foll-name">${meta.label}</span></div>
    <div class="om-foll-count">${fmt(n.current)}</div>
    <div class="om-foll-sub">Follower</div>
    ${sparkline(n.spark, meta.color)}
    <div class="om-foll-deltas">
      ${deltaTag("7T", n.d7)}${deltaTag("30T", n.d30)}${deltaTag("90T", n.d90)}
    </div>
    ${reichweiteZeile(reich[n.channel], tage)}
  </div>`;
}

// Abschlusskachel: Was von der Reichweite auf der Website ankommt. Follower und Reichweite sind
// Zwischengroessen — erst hier wird sichtbar, ob daraus Besuche und Bestellungen werden.
// Eigene Posts und Anzeigen stehen getrennt (Uli 05.10.2026): Die Summe ließ die Anzeigenkäufe
// wie einen Erfolg der eigenen Posts aussehen.
const datum = (iso: string, mitJahr: boolean): string => {
  const [j, m, t] = iso.split("-");
  return mitJahr ? `${t}.${m}.${j}` : `${t}.${m}.`;
};
const euro = (n: number): string => `${fmt(n)} €`;
const bestellungen = (n: number, wo: string): string =>
  `<b>${fmt(n)}</b> <span>Bestellung${n === 1 ? "" : "en"} ${wo}</span>`;

function sitzungsKachel(s: Sitzungen | null): string {
  if (!s) return "";
  const gesamt = s.organisch + s.bezahlt;
  // Ältere Antworten ohne Aufteilung: alles als Summe zeigen statt falsch zuzuordnen.
  const geteilt = s.orgKaeufe !== undefined && s.paidKaeufe !== undefined;
  const bloecke = geteilt
    ? `<div class="om-foll-reach">
        ${bestellungen(s.orgKaeufe ?? 0, "aus eigenen Posts")}
        <i>${fmt(s.organisch)} Besuche · ${euro(s.orgUmsatz ?? 0)} Umsatz · kostenlos</i>
      </div>
      <div class="om-foll-reach">
        ${bestellungen(s.paidKaeufe ?? 0, "aus Anzeigen")}
        <i>${fmt(s.bezahlt)} Besuche · ${euro(s.paidUmsatz ?? 0)} Umsatz${s.paidKosten ? ` · ${euro(s.paidKosten)} Kosten` : ""}</i>
      </div>`
    : `<div class="om-foll-reach">
        ${bestellungen(s.kaeufe, "daraus")}
        <i>${euro(s.umsatz)} Umsatz</i>
      </div>`;
  return `<div class="om-foll-card om-foll-card--sessions" style="border-top-color:#c04830">
    <div class="om-foll-head">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#c04830" stroke-width="2">
        <path d="M3 3v18h18"/><path d="M7 14l4-4 3 3 5-6"/></svg>
      <span class="om-foll-name">Website-Besuche aus Social</span>
    </div>
    <div class="om-foll-count">${fmt(gesamt)}</div>
    <div class="om-foll-sub">Sitzungen in ${s.tage} Tagen · ø ${fmt(s.proWoche)}/Woche</div>
    ${bloecke}
    <div class="om-foll-note">Google Analytics, ${datum(s.von, false)}–${datum(s.bis, true)} · Bestellungen, keine bezahlten Rechnungen; erfasst nur Besucher mit Zustimmung</div>
  </div>`;
}

export function initFollowersTab(m: HTMLElement, deps: MarketingDeps): void {
  const host = m.querySelector("[data-foll-grid]") as HTMLElement | null;
  const stamp = m.querySelector("[data-foll-stamp]") as HTMLElement | null;
  const msg = m.querySelector('[data-msg="followers"]') as HTMLElement | null;
  if (!host) return;

  const load = async (): Promise<void> => {
    const r = await deps.api<FollowersResponse>("/api/marketing/followers");
    const nets = r.data?.networks ?? [];
    if (!nets.length) {
      host.innerHTML = '<p class="dim">Noch keine Follower-Daten. „Aktualisieren" startet den Metricool-Pull.</p>';
      if (stamp) stamp.textContent = "";
      return;
    }
    const reich = r.data?.reichweite ?? {};
    const tage = r.data?.reichweiteTage ?? 90;
    const s = r.data?.sitzungen ?? null;
    host.innerHTML = nets.map((n) => card(n, reich, tage)).join("") + sitzungsKachel(s);
    const total = nets.reduce((s2, n) => s2 + n.current, 0);
    if (stamp) stamp.textContent = `Gesamt ${fmt(total)} Follower · Stand ${deps.formatDate(nets[0]!.capturedAt)}`;
  };

  wireMotorRun({
    deps, modal: m,
    btn: m.querySelector('[data-action="run-followers"]'),
    msg, jobType: "social_analytics",
    runUrl: "/api/marketing/motors/social_analytics/run",
    onDone: load,
  });

  void load();
}
